const loadTeasers = async function (url, teaserElement, options = {}) {
    try {
        const response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(options)
        });
        if (!response.ok) {
            teaserElement.innerHTML = 'Ein Fehler ist aufgetreten...';
            return false;
        }
        const teasers = await response.text();
        if (!teasers) return false;
        teaserElement.insertAdjacentHTML('beforeend', teasers);
        return true;
    } catch (err) {
        teaserElement.innerHTML = 'Ein Fehler ist aufgetreten...';
        return false;
    }
}

export default loadTeasers;